"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const __1 = require("../../..");
const Footer_1 = require("../Footer");
function FooterContactItem({ children }) {
    const { slim } = (0, Footer_1.useFooterContext)();
    return slim ? ((0, jsx_runtime_1.jsx)(__1.Grid.Col, { width: "auto", mobile: 12, desktop: "auto", children: (0, jsx_runtime_1.jsx)("div", { className: "usa-footer__contact-info", children: children }) })) : ((0, jsx_runtime_1.jsx)(__1.Grid.Col, { width: "auto", children: children }));
}
exports.default = FooterContactItem;
